import { render, staticRenderFns } from "./RequestAddress.vue?vue&type=template&id=2ed34e14&scoped=true&"
import script from "./RequestAddress.vue?vue&type=script&lang=js&"
export * from "./RequestAddress.vue?vue&type=script&lang=js&"
import style0 from "./RequestAddress.vue?vue&type=style&index=0&id=2ed34e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed34e14",
  null
  
)

export default component.exports